module.exports = __webpack_public_path__ + "img/gh-30282-1-98.prt.97e1b4fa.jpg";